/**
 * OperationalLineageGraphControls
 *
 * Zoom in / zoom out / reset controls for the lineage graph canvas.
 * Compact, non-intrusive operational controls.
 */

import React from 'react';
import { NEUTRAL, TYPOGRAPHY, SPACING } from '../../../modules/governanceEventStream/operationalVisualLanguage/index.js';

interface Props {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

const btnStyle: React.CSSProperties = {
  width: 28,
  height: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: NEUTRAL.bg300,
  border: `1px solid ${NEUTRAL.border}`,
  borderRadius: 3,
  color: NEUTRAL.text400,
  fontSize: TYPOGRAPHY.label.size,
  fontWeight: TYPOGRAPHY.label.weight,
  cursor: 'pointer',
  padding: 0,
  fontFamily: 'system-ui, sans-serif',
};

export const OperationalLineageGraphControls: React.FC<Props> = ({ zoom, onZoomIn, onZoomOut, onReset }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: SPACING.sp1,
        backgroundColor: NEUTRAL.bg200,
        border: `1px solid ${NEUTRAL.borderSubtle}`,
        borderRadius: 3,
        padding: SPACING.sp2,
      }}
      data-testid="lineage-graph-controls"
    >
      <button type="button" style={btnStyle} onClick={onZoomIn} title="Zoom in" data-testid="lineage-zoom-in">
        +
      </button>
      <button type="button" style={btnStyle} onClick={onZoomOut} title="Zoom out" data-testid="lineage-zoom-out">
        −
      </button>
      <button type="button" style={btnStyle} onClick={onReset} title="Reset view" data-testid="lineage-zoom-reset">
        ◎
      </button>
      <div
        style={{
          textAlign: 'center',
          fontSize: TYPOGRAPHY.micro.size,
          color: NEUTRAL.text300,
          fontFamily: TYPOGRAPHY.mono.family,
          marginTop: SPACING.sp1,
        }}
      >
        {Math.round(zoom * 100)}%
      </div>
    </div>
  );
};
